export const usePdfPrinter = () => {
  /**
   * 🖨️ Imprime un PDF en base64 abriéndolo en una ventana temporal.
   *
   * @param dataUrl  PDF codificado en base64 (con o sin prefijo)
   * @param fileName Nombre mostrado en la pestaña
   */
  const printBase64Pdf = (dataUrl: string, fileName = 'documento.pdf') => {
    if (!dataUrl || typeof dataUrl !== 'string') {
      console.warn('⚠️ No se puede imprimir: el archivo base64 está vacío o es inválido');
      return;
    }

    const normalizedDataUrl = dataUrl.startsWith('data:application/pdf')
      ? dataUrl
      : `data:application/pdf;base64,${dataUrl}`;

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      console.error('❌ No se pudo abrir la ventana de impresión');
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
            iframe { width: 100%; height: 100%; border: none; }
          </style>
        </head>
        <body>
          <iframe src="${normalizedDataUrl}" id="pdfFrame"></iframe>
          <script>
            const iframe = document.getElementById('pdfFrame');
            iframe.onload = function () {
              setTimeout(() => {
                iframe.contentWindow.print();
                setTimeout(() => window.close(), 500);
              }, 400);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  return { printBase64Pdf };
};
